import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { SharedService } from 'app/modules/common/services/shared-service';
import { EmployeeStoreService } from 'app/modules/employee/services/employee-store.service';
import { EmployeeService } from 'app/modules/employee/services/employee.service';
import { CompanyTreeViewService } from 'app/modules/fuse/components/tree-view/service/company-tree-view.service';
import { finalize } from 'rxjs/operators';

@Component({
    selector: 'app-mover',
    templateUrl: './mover.component.html',
    styleUrls: ['./mover.component.scss'],
    standalone: false
})
export class MoverComponent {

    public form: UntypedFormGroup;
    private selectedCompanyId: number;
    public isSaving = false;


    constructor(
        public dialogRef: MatDialogRef<MoverComponent>,
        private employeeService: EmployeeService,
        private sharedService: SharedService,
        private employeeStoreService: EmployeeStoreService,
        fb: UntypedFormBuilder,
    ) {

        // set initial selected company ID from local storage
        this.selectedCompanyId = parseInt(localStorage.getItem("Empresa"));

        // init form group
        this.form = fb.group({
            "moveLeaves": true
        });
    }


    // move employee
    public moveEmployee(employeeId: number) {

        // set loading screen
        this.isSaving = true;

        this.employeeService.moveEmployee(
            employeeId,
            this.selectedCompanyId,
            this.form.controls["moveLeaves"].value
        )
            .pipe(
                finalize(() => this.isSaving = false)
            )
            .subscribe(res => {

                if (res.code === 0) {

                    // notify changes and close the dialog.
                    this.employeeStoreService.updateAllEmployeeViews(employeeId);
                    this.dialogRef.close();

                } else {
                    console.error("Server Error: " + res.message);
                    this.sharedService.ShowSnackBar("lo siento, el proceso falló");
                }

            }, err => {
                console.error(err);
                this.sharedService.ShowSnackBar("lo siento, el proceso falló");
            });

    }


    // handle accept dialog click
    public onAccept() {

        // get selected employee ID
        const selectedEmployeeID = parseInt(localStorage.getItem("EmplooyeeID"));

        // move employee
        this.moveEmployee(selectedEmployeeID);

    }


    // handle close dialog click
    public onCancel(): void {
        this.dialogRef.close();
    }


    // handle company select from tree view
    public onCompanySelcted(e: { id: string; }) {
        this.selectedCompanyId = parseInt(e.id);
    }

}
